module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq630-f5c8fb920c7f9c37f78cbdd294b18b6c.jpg";